import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import DataObjectOutlinedIcon from "@mui/icons-material/DataObjectOutlined";
import { IVariavelComunicado } from "interfaces/comunicado";
import { COMUNICADO_ACCENT, COMUNICADO_ACCENT_SOFT } from "./comunicado-composer.theme";

type Props = {
  variaveis: IVariavelComunicado[];
  onInsert: (chave: string) => void;
};

export default function ComunicadoVariaveisHelper({ variaveis, onInsert }: Props) {
  if (variaveis.length === 0) return null;

  const grupos = variaveis.reduce<Record<string, IVariavelComunicado[]>>((acc, v) => {
    const g = v.grupos?.[0] ?? "Geral";
    if (!acc[g]) acc[g] = [];
    acc[g].push(v);
    return acc;
  }, {});

  return (
    <Box
      sx={{
        p: { xs: 1.25, sm: 1.5 },
        borderRadius: 1.5,
        bgcolor: COMUNICADO_ACCENT_SOFT,
        border: "1px dashed",
        borderColor: "rgba(249, 96, 48, 0.35)",
        maxHeight: { xs: 140, sm: 180 },
        overflow: "auto",
      }}
    >
      <Stack direction="row" spacing={0.75} alignItems="center" mb={1}>
        <DataObjectOutlinedIcon sx={{ fontSize: "1rem", color: COMUNICADO_ACCENT }} />
        <Typography variant="caption" fontWeight="bold" color="text.secondary">
          Variáveis dinâmicas — clique para inserir no texto
        </Typography>
      </Stack>

      <Stack spacing={1.25}>
        {Object.entries(grupos).map(([grupo, items]) => (
          <Box key={grupo}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              mb={0.5}
              sx={{ textTransform: "uppercase", letterSpacing: 0.6, fontSize: "0.65rem" }}
            >
              {grupo}
            </Typography>
            <Stack direction="row" flexWrap="wrap" gap={0.5}>
              {items.map((v) => (
                <Tooltip key={v.chave} title={`${v.descricao} · ex: ${v.exemplo}`} arrow>
                  <Chip
                    size="small"
                    label={`{{${v.chave}}}`}
                    onClick={() => onInsert(v.chave)}
                    sx={{
                      cursor: "pointer",
                      fontFamily: "monospace",
                      fontSize: "0.72rem",
                      bgcolor: "background.paper",
                      "&:hover": {
                        bgcolor: COMUNICADO_ACCENT,
                        color: "#fff",
                      },
                    }}
                  />
                </Tooltip>
              ))}
            </Stack>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
